import React, {useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {SlideRefContext} from '../../../../../context/SlideRefContext';
import {DeviceType} from '../../../../../incase-domain/common/DeviceType.enum';
import Button from '../../../../../incase-domain/components/button/Button';
import {TEMPLATE} from '../../../../../service/template/types';
import {addSlidesAction} from '../../../../../store/actions/edit';
import {selectedPresentationSelector, selectedViewSelector} from '../../../../../store/selectors/presentation.selectors';
import {selectedSlideSelector} from '../../../../../store/selectors/slide.selectors';
import {useSlideClickHandler} from '../../../../../utils/hooks/useHandleSlideClick';
import SlideContainer from './SlideContainer';
import SlideContainerMobile from './SlideContainerMobile';

export const SLIDE_CONTAINER_WRAPPER = 'slide-container-wrapper';

function SlidesContainerWrapper(): JSX.Element {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const handleSlideClick = useSlideClickHandler();

    const selectedPresentation = useSelector(selectedPresentationSelector);
    const slide = useSelector(selectedSlideSelector);
    const selectedView = useSelector(selectedViewSelector);

    const {slidesContainerWrapperRef} = useContext(SlideRefContext);

    return (
        <div
            ref={slidesContainerWrapperRef}
            className={`p-presEdit__slideContainer--${selectedView === DeviceType.MOBILE ? 'mobile' : 'desktop'}`}
            id={SLIDE_CONTAINER_WRAPPER}
            onClick={(e) => handleSlideClick(e, SLIDE_CONTAINER_WRAPPER)}
        >
            {selectedPresentation.slides.length > 0 && slide ? (
                <>{selectedView === DeviceType.MOBILE ? <SlideContainerMobile key={slide._id} /> : <SlideContainer key={slide._id} />}</>
            ) : (
                <Button
                    variant="solid"
                    color="secondary"
                    size="sm"
                    wide
                    onClick={() => dispatch(addSlidesAction(1, false, TEMPLATE.BLANK, true))}
                >
                    {t('presEditPage.addSlide')}
                </Button>
            )}
        </div>
    );
}

export default SlidesContainerWrapper;
